'use strict';
import Base  from './DashboardBase';
import Render  from './DashboardRender';
import { connect } from 'react-redux';

class Dashboard extends Base {
    render() {
        return Render.call(this, this.props, this.state);
    }
}

export default Dashboard = connect((state)=>{
    return {user:state.user || {}}
})(Dashboard);